import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  ActivatedRoute,
  RouterStateSnapshot,
  UrlTree
} from "@angular/router";
import * as moment from "moment";
import { AuthenticationService } from "../services/auth.service";
import { TogglesValidation } from "../helpers/toggles";
import { TogglesConfiguration } from "../enum/toggles-configuration.enum";
import { RolesUsersEnum } from "../enum/roles-users.enum";

@Injectable({
  providedIn: "root"
})
export class AuthGuard implements CanActivate {
  can: boolean = true;
  NOT_DESKTOP: boolean = window.innerWidth <= 500;
  NOT_TABLET: boolean = window.innerWidth > 500 && window.innerWidth <= 1200;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) {}

  async canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const user = this.authenticationService.getCurrentUser();

    if (!user) {
      this.authenticationService.logout();
      return this.router.navigate(["/login"]);
    }

    if (!this.NOT_DESKTOP && !this.NOT_TABLET) {
      const body = document.querySelector("body");
      if (user) {
        let scriptCode = document.createElement("script");
        scriptCode.innerHTML =
          "var $_Huggy = { defaultCountry: '+55', uuid: 'ed57c8d8-3a2a-4ee8-8c88-92695e00dbed' , company: '326899', name: " +
          JSON.stringify(user.name) +
          ", phone: " +
          JSON.stringify(user.phone) +
          ", email: " +
          JSON.stringify(user.email) +
          "}; (function (i, s, o, g, r, a, m) { i[r] = { context: { id:'8f0715e9c4e617d3e5b4f415a651ce90' } }; a = o; o = s.createElement(o); o.async = 1; o.src = g; m = s.getElementsByTagName(a)[0]; m.parentNode.insertBefore(o, m); })(window, document, 'script', 'https://js.huggy.chat/widget.min.js', 'pwz')";

        let scriptUrl = document.createElement("script");
        scriptUrl.src = "https://cdn.pluggy.ai/pluggy-connect/v0.1.1/pluggy-connect.js";

        body.append(scriptCode);
        body.append(scriptUrl);
      }
    }

    if (user && TogglesValidation.toggleShow(TogglesConfiguration.AMPLIFIQUE_ME) && user.created_at && user.roles !== RolesUsersEnum.ADMIN) {
      const now = new Date();
      const createdAt = new Date(user.created_at);
      const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
      const timeDifferenceInMs = now.getTime() - createdAt.getTime();

      if (timeDifferenceInMs === thirtyDaysInMs) {
        const body = document.querySelector("body");

        let amplifiqueTag = document.createElement("ampl-survey");
        amplifiqueTag.setAttribute("identifier", "638606aea1a51631a5dd3ea3");


        let scriptAmplifiqueUrl = document.createElement("script");
        scriptAmplifiqueUrl.src = "https://cdn.amplifique.me/amplifiqueme-inapp-survey.js";

        let scriptAmplifiqueCode = document.createElement("script");
        scriptAmplifiqueCode.innerHTML =
          " window.Amplifiqueme = {}; window.Amplifiqueme.onLoad = ()=> { window.Amplifiqueme.identify({email: " +
          JSON.stringify(user.email) +
          ", custom_fields: { gerente_de_sucesso: " + JSON.stringify(user.officer_bitrix?.id) +
          "}}, true)}";

        body.append(amplifiqueTag);
        body.append(scriptAmplifiqueUrl);
        body.append(scriptAmplifiqueCode);
      }
      return this.can;
    }
  }
}
